import CloseIcon from "@mui/icons-material/Close";
import { Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../../components/Comman/Button";
import DynamicTable from "../../../components/Comman/RT/MaterialUIRTTable";
import { LabelCompo } from "../../../components/Comman/Label";
import { redColor, titleColor } from "../../../config/ColorObj";
import DynamicDetails from "../../../components/dynamicscreens/DynamicDetails";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const OrderToExistPopUp = ({
    handleCloses,
    open,
    columns,
    rows,
    onSubmit,
    selectedRowData,
}) => {

    const [firmNameWithType, setFirmNameWithType] = React.useState("-");
    React.useEffect(() => {
        const newFirmName = selectedRowData?.firmNameWithType !== null
            ? selectedRowData.firmNameWithType
            : "-";
        setFirmNameWithType(newFirmName);
    }, [selectedRowData]);


    const handleClose = () => {
        handleCloses();
    };

    const rowStatus = () => {

    }

    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                maxWidth="lg"
            >

                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    Stock Holder List
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <DynamicDetails />
                    <Typography variant="body2" color={redColor} sx={{ mb: 2 }}>
                        Below stock holders are still giving order to {firmNameWithType}. Are you sure you want to inactive it?
                    </Typography>
                    <DynamicTable
                        data={rows}
                        tableHead={columns}
                        showPegination={false}
                        isActionColActive={false}
                        rowStatus={rowStatus}
                        filterDataExcel={true}
                        screenTitle={"Stock Holder"}
                    />
                    <br />
                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="right"
                    >
                        <ButtonCompo
                            size="medium"
                            type="submit"
                            variant="contained"
                            name={"Submit"}
                            onClick={onSubmit}
                        />
                    </Grid>
                </DialogContent>
            </BootstrapDialog>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OrderToExistPopUp);
